import { IconButton, Tooltip } from '@chakra-ui/react';
import { useSidebarContext } from 'context/SidebarContext';
import { useTranslation } from 'react-i18next';
import { LuPanelRightClose, LuPanelRightOpen } from 'react-icons/lu';

export const SidebarToggleButton = () => {
  const { t } = useTranslation();
  const { isCollapsed, setIsCollapsed } = useSidebarContext();
  const label = isCollapsed ? t('sidebar:expand') : t('sidebar:collapse');

  return (
    <Tooltip label={label} placement="right" hasArrow openDelay={200}>
      <IconButton
        variant="unstyled"
        w="3rem"
        h="3rem"
        minW="3rem"
        display="flex"
        color="white"
        borderRadius="md"
        _hover={{ bg: 'whiteAlpha.400' }}
        paddingInline={0}
        aria-label={label}
        icon={isCollapsed ? <LuPanelRightClose size="20" /> : <LuPanelRightOpen size="20" />}
        onClick={() => setIsCollapsed((collapsed) => !collapsed)}
      />
    </Tooltip>
  );
};
